import z from "zod";
import { PaginationSchema } from "../common";
import { FeatureSchema } from "./entity";

export const FeatureSchemas = {
  list: PaginationSchema.extend({
    nameEn: z.string().optional(),
    sort: z.string().optional(),
  }),

  create: FeatureSchema.omit({ id: true, createdAt: true, updatedAt: true }).extend({ slug: z.string().optional() }),

  seed: FeatureSchema.omit({ updatedAt: true, createdAt: true }),

  update: z.object({
    id: z.uuidv7(),
    slug: z.string().optional(),
    nameEn: z.string().trim().min(3),
    nameAr: z.string().trim().min(3),
    nameTr: z.string().trim().min(3).catch("Name TR"),
    nameFa: z.string().trim().min(3).catch("Name FA"),
  }),

  delete: z.object({ id: z.uuidv7() }),
};

export type Feature = z.infer<typeof FeatureSchema>;
export type CreateFeature = z.infer<typeof FeatureSchemas.create>;
export type UpdateFeature = z.infer<typeof FeatureSchemas.update>;
